import {ErrorOutline} from '@material-ui/icons';
import React from 'react';
import 'Shared/components/Alert.sass';

export const STANDARD_ERROR = 'An error occurred. Please try again and contact support if this issue persists.';

type AlertProps = {
  message: string;
  className?: string;
};

const Alert = (props: AlertProps) => {
  return (
    <div className={`alert ${props.className || ''}`}>
      <ErrorOutline className="alert__icon" />
      <span className="alert__message">{props.message}</span>
    </div>
  );
};

export default Alert;
